"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.n = (module)=>{
        var getter = module && module.__esModule ? ()=>module['default'] : ()=>module;
        __webpack_require__.d(getter, {
            a: getter
        });
        return getter;
    };
})();
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    default: ()=>RealTimeAudioPanel
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const external_react_namespaceObject = require("react");
var external_react_default = /*#__PURE__*/ __webpack_require__.n(external_react_namespaceObject);
const external_styled_components_namespaceObject = require("styled-components");
var external_styled_components_default = /*#__PURE__*/ __webpack_require__.n(external_styled_components_namespaceObject);
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const BotWithAnimatedBorder_js_namespaceObject = require("./components/Realtime/BotWithAnimatedBorder/BotWithAnimatedBorder.js");
var BotWithAnimatedBorder_js_default = /*#__PURE__*/ __webpack_require__.n(BotWithAnimatedBorder_js_namespaceObject);
const RealTimeHeader_js_namespaceObject = require("./components/Realtime/RealTimeHeader/RealTimeHeader.js");
var RealTimeHeader_js_default = /*#__PURE__*/ __webpack_require__.n(RealTimeHeader_js_namespaceObject);
const RenderMarkers_js_namespaceObject = require("./components/Realtime/RenderMarkers/RenderMarkers.js");
var RenderMarkers_js_default = /*#__PURE__*/ __webpack_require__.n(RenderMarkers_js_namespaceObject);
const analytics_js_namespaceObject = require("./analytics/analytics.js");
var analytics_js_default = /*#__PURE__*/ __webpack_require__.n(analytics_js_namespaceObject);
const useRealTimeChatCoordinator_js_namespaceObject = require("./hooks/useRealTimeChatCoordinator.js");
const browserStorage_js_namespaceObject = require("./utils/browserStorage.js");
const useChatMessagesContext_js_namespaceObject = require("./hooks/useChatMessagesContext.js");
const useLoadingStateContext_js_namespaceObject = require("./hooks/useLoadingStateContext.js");
const useRealTimeContext_js_namespaceObject = require("./hooks/useRealTimeContext.js");
const Container = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "RealTimeAudioPanel__Container"
})([
    "z-index:1510;height:",
    ";left:",
    ";top:",
    ";width:100%;position:absolute;background:linear-gradient( 144.03deg,#7701bb 26.24%,#7601bb 30.85%,#7503bc 35.32%,#7205bd 39.67%,#6e09bf 43.9%,#690dc1 48.03%,#6312c4 52.1%,#5c18c7 56.1%,#541fca 60.07%,#4c27ce 64.01%,#422fd2 67.94%,#3738d7 71.89%,#2c42dc 75.87%,#204de1 79.89%,#1358e7 83.98%,#0564ed 88.15% ),radial-gradient( 37.63% 77.06% at -3.33% 9.11%,rgba(245,235,250,0.6) 0%,rgba(238,222,246,0.51875) 16.15%,rgba(232,210,243,0.441421) 33.33%,rgba(209,168,232,0.174338) 66.15%,rgba(201,153,228,0.0827664) 82.29%,rgba(194,140,224,0) 100% ),radial-gradient( 22.92% 32.88% at 93.06% 103.5%,rgba(232,242,255,0) 0%,rgba(232,242,255,0) 0.01%,rgba(153,195,249,0) 100% );"
], ({ isModal })=>isModal ? '100%' : 'calc(100% - 66px)', ({ isModal })=>isModal ? 'unset' : '0', ({ isModal })=>isModal ? 'unset' : '66px');
const HeaderWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "RealTimeAudioPanel__HeaderWrapper"
})([
    "height:57px;justify-content:center;align-items:center;position:absolute;top:0;z-index:1;"
]);
const BodyWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "RealTimeAudioPanel__BodyWrapper"
})([
    "flex-grow:1;justify-content:center;align-items:center;flex-direction:column;"
]);
const MarkerPanel = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "RealTimeAudioPanel__MarkerPanel"
})([
    "overflow-y:auto;position:relative;"
]);
const FooterWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Absolute).withConfig({
    displayName: "RealTimeAudioPanel__FooterWrapper"
})([
    "bottom:16px;height:48px;width:100%;background:transparent;"
]);
const ControlWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Flex).withConfig({
    displayName: "RealTimeAudioPanel__ControlWrapper"
})([
    "align-items:center;justify-content:space-between;height:48px;"
]);
const Mic = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "RealTimeAudioPanel__Mic"
})([
    "cursor:pointer;border-radius:50%;width:45px;height:45px;background:transparent;display:flex;align-items:center;justify-content:center;"
]);
const Close = /*#__PURE__*/ external_styled_components_default()(Mic).withConfig({
    displayName: "RealTimeAudioPanel__Close"
})([
    "background:transparent;"
]);
const ChildWrapper = /*#__PURE__*/ external_styled_components_default()(external_pcln_design_system_namespaceObject.Box).withConfig({
    displayName: "RealTimeAudioPanel__ChildWrapper"
})([
    "height:100%;display:flex;position:absolute;bottom:10%;"
]);
const RealTimeAudioPanel_RealTimeAudioPanel = ({ realtimeContext, locale, requestFrom, isCustomVoice = false, isModal = false })=>{
    const { setLoadingStatus } = (0, useLoadingStateContext_js_namespaceObject.useLoadingStateContext)();
    const { setStartRealTime } = (0, useRealTimeContext_js_namespaceObject.useRealTimeContext)();
    const { setChatMessages } = (0, useChatMessagesContext_js_namespaceObject.useChatMessagesContext)();
    const pennysid = browserStorage_js_namespaceObject.browserStorageManager.getBrowserStorage()?.getItem('pennysid') ?? '';
    const { isMuted, messages, marker, mediaStream, startChat, stopChat, toggleMute, setMarker } = (0, useRealTimeChatCoordinator_js_namespaceObject.useRealTimeChatCoordinator)({
        locale,
        realtimeContext,
        analytics: analytics_js_default(),
        baseUrl: window.location.origin,
        onLoadingChange: setLoadingStatus,
        onOpenStateChange: setStartRealTime,
        pennysid,
        requestFrom,
        isCustomVoice
    });
    (0, external_react_namespaceObject.useEffect)(()=>{
        startChat();
    }, []);
    (0, external_react_namespaceObject.useEffect)(()=>{
        setChatMessages(messages);
    }, [
        messages
    ]);
    function handleStopChatClick() {
        stopChat();
        setStartRealTime(false);
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Container, {
        isModal: isModal,
        "data-testid": "real-time-audio-panel",
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Flex, {
            flexDirection: 'column',
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(BodyWrapper, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(HeaderWrapper, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RealTimeHeader_js_default(), {})
                    }),
                    marker?.markerItem?.displayComponentName ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(MarkerPanel, {
                        "data-testid": "marker-panel",
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(RenderMarkers_js_default(), {
                            markerToDisplay: marker,
                            "data-testid": "marker-display",
                            setMarker: setMarker
                        })
                    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(ChildWrapper, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(BotWithAnimatedBorder_js_default(), {
                            isMuted: isMuted,
                            mediaStream: mediaStream
                        })
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(FooterWrapper, {
                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(ControlWrapper, {
                            px: 3,
                            children: [
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Mic, {
                                    onClick: toggleMute,
                                    "data-testid": "toggle-mute",
                                    children: isMuted ? /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                                        top: "3px",
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.MicOff, {
                                            size: '30px',
                                            color: '#fff',
                                            "data-testid": "mute-enabled"
                                        })
                                    }) : /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Relative, {
                                        top: "3px",
                                        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Microphone, {
                                            size: '30px',
                                            color: '#fff',
                                            "data-testid": "mute-disabled"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(Close, {
                                    onClick: handleStopChatClick,
                                    "data-testid": "close-chat",
                                    children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.Close, {
                                        size: '30px',
                                        color: '#fff'
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
};
const RealTimeAudioPanel = /*#__PURE__*/ external_react_default().memo(RealTimeAudioPanel_RealTimeAudioPanel);
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
